import React, { memo, useState } from 'react';
import { Blok } from '../../../interfaces/Blok.interface';
import { LinkProps } from '../../../interfaces/LinkProps.interface';
import { ButtonSize } from '../../../interfaces/enums/ButtonSize.enum';
import { ButtonType } from '../../../interfaces/enums/ButtonType.enum';
import { Theme } from '../../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../../BlokWrapper/BlokWrapper';
import ButtonLink from '../../ButtonLink/ButtonLink';
import StoryblokLinkProvider from '../../Utils/StoryblokLinkProvider/StoryblokLinkProvider';
import Grid from '../../Utils/Grid/Grid';
import Col from '../../Utils/Col/Col';
import { StoryblokComponent } from 'gatsby-source-storyblok';

interface SideNavButtonsProps {
  primary_cta: Blok[];
  secondary_cta: Blok[];
}

const SideNavButtons: React.FC<SideNavButtonsProps> = ({
  primary_cta,
  secondary_cta,
}) => {
  return (
    <div className={`relative p-6`}>
      <div className="grid grid-cols-12 gap-6">
        <Col span={{ sm: 6 }}>
          {primary_cta?.map((cta: Blok) => (
            <StoryblokComponent blok={cta} key={cta._uid} />
          ))}
        </Col>
        <Col span={{ sm: 6 }}>
          {secondary_cta?.map((cta: Blok) => (
            <StoryblokComponent blok={cta} key={cta._uid} />
          ))}
        </Col>
      </div>
      <div className="absolute top-[100%] bg-[#0b212e] w-full height-[300px] left-0 right-0"></div>
    </div>
  );
};

export default memo(withBlokWrapper(SideNavButtons, Theme.DARK, 'h-auto'));
